import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useT } from "@/lib/i18n";
import { reviewUspText } from "@/lib/reviews";
import { kiyohScoreLabel, useKiyohStats } from "@/lib/kiyoh-stats";

// USP's die één voor één over de blauwe huisstijl-balk rouleren; elke USP linkt
// naar de pagina die 'm onderbouwt.
const USPS: { text: string; href: string; review?: true }[] = [
  { text: "120+ jaar ervaring", href: "/over-ons" },
  { text: "Snelle en veilige levering", href: "/levertijden" },
  { text: "Maatwerk in een paar klikken", href: "/glassoorten" },
  { text: reviewUspText, href: "/reviews", review: true },
];

const ROTATE_MS = 3500;

/** Dunne blauwe balk bovenaan die de USP's wit, één voor één, laat zien. */
export function UspTicker() {
  const t = useT();
  const [i, setI] = useState(0);
  // Zie UspRow: de review-USP wordt "Beoordeeld met een 9,4" zodra Kiyoh een cijfer heeft.
  const stats = useKiyohStats();

  useEffect(() => {
    const id = setInterval(() => setI((n) => (n + 1) % USPS.length), ROTATE_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="bg-[#013878] text-white">
      <div className="mx-auto flex h-8 max-w-[1600px] items-center justify-center overflow-hidden px-4 text-center">
        <ul aria-live="polite" className="relative w-full">
          {USPS.map((usp, idx) => (
            <li
              key={usp.text}
              aria-hidden={idx !== i}
              className={`absolute inset-0 flex items-center justify-center transition-opacity duration-500 ${
                idx === i ? "opacity-100" : "opacity-0"
              }`}
            >
              <Link
                to={usp.href}
                tabIndex={idx === i ? 0 : -1}
                className="flex items-center gap-1.5 text-xs font-semibold text-white transition hover:underline sm:text-sm"
              >
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="shrink-0 text-white">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                {usp.review && stats ? `${t("Beoordeeld met een")} ${kiyohScoreLabel(stats.average)}` : t(usp.text)}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
